/**
 * Reads the JS-readable `workpay_realm` cookie set by the BFF at login. The
 * value is the tenant realm / subdomain. Available for future branding /
 * pre-bootstrap routing — no behaviour is currently wired to it.
 */
const REALM_COOKIE_NAME = 'workpay_realm';

export function getRealm(): string | null {
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${REALM_COOKIE_NAME}=`));
  if (!match) return null;
  const value = match.slice(REALM_COOKIE_NAME.length + 1);
  return value ? decodeURIComponent(value) : null;
}
